export const DEBT_OWNER_HEADER = 'Whose debt'

const OWNER_LABEL = {
  applicant: 'Applicant',
  'co-applicant': 'Co-applicant',
  both: 'Both',
}

export const describeDebtOwner = (source) => OWNER_LABEL[source] || '—'

export const hasDebtOwnerAttribution = (rows = []) =>
  rows.some(row => Boolean(OWNER_LABEL[row?.source]))
